import React from 'react';

import './Eingabe.css';

class Kulissenspaltbreite extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
      Kulissenspaltbreite: 100,
    };
    this.handleChange = this.handleChange.bind(this);
    }

  handleChange(value) {
        this.props.KulissenspaltbreiteChange(value);
  }

    getKulissenspaltbreite = () => {
        let d_s;
        let B_Ka = parseFloat(this.props.Kanalbreite);
        let n_K = parseFloat(this.props.AnzahlKulissen);
        let d_K = parseFloat(this.props.Kulissenbreite);
        d_s = ((B_Ka - (n_K * d_K)) / (n_K));
        this.handleChange(d_s);
        return d_s;
  }

  render() {
    this.handleChange(this.getKulissenspaltbreite())
    return this.getKulissenspaltbreite().toFixed(0);
  }
}
export default Kulissenspaltbreite;
